import React from 'react';

function ErrorPage({ userType }) {
  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#0b0e15'
    }}>
      <div style={{
        backgroundColor: '#1c1e24',
        padding: '2rem',
        borderRadius: '12px',
        maxWidth: '500px',
        textAlign: 'center',
        border: '1px solid #dc3545'
      }}>
        <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>
          ❌ User Type Not Supported
        </h2>
        <p style={{ color: '#a3a8b8', marginBottom: '1.5rem', fontSize: '18px' }}>
          The user type <strong style={{ color: '#ffffff' }}>"{userType || 'unknown'}"</strong> is not supported.
        </p>
        <p style={{ color: '#a3a8b8', marginBottom: '2rem' }}>
          Please use one of the following supported user types:
        </p>
        <div style={{ marginBottom: '2rem' }}>
          <div style={{
            backgroundColor: '#272a31',
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '1rem',
            border: '1px solid #28a745'
          }}>
            <strong style={{ color: '#28a745' }}>?userType=coach</strong>
            <p style={{ color: '#a3a8b8', marginTop: '0.5rem', fontSize: '14px' }}>
              For coaching professionals
            </p>
          </div>
          <div style={{
            backgroundColor: '#272a31',
            padding: '1rem',
            borderRadius: '8px',
            border: '1px solid #007bff'
          }}>
            <strong style={{ color: '#007bff' }}>?userType=coachee</strong>
            <p style={{ color: '#a3a8b8', marginTop: '0.5rem', fontSize: '14px' }}>
              For students/learners
            </p>
          </div>
        </div>
        <button
          onClick={() => window.location.href = '/'}
          style={{
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: 'none',
            backgroundColor: '#6c757d',
            color: '#ffffff',
            fontSize: '16px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Return to Homepage
        </button>
      </div>
    </div>
  );
}

export default ErrorPage;
